export enum ProjectCommands {
  Projects = 'Projects',
}

export interface JsonProject {
  id: number;
  name: string;
  activeAccountsCount?: number;
}

export interface JsonProjectResponse {
  command: ProjectCommands.Projects;
  list: JsonProject[];
  companies: string[];
}
